
/**
 * MAIN.TSX - APPLICATION ENTRY POINT
 * ==================================
 * 
 * This is the entry point for our React application. It:
 * 1. Imports our global CSS styles
 * 2. Creates the React root element
 * 3. Renders the main App component
 * 4. Enables React StrictMode for development checks
 */

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Get the root DOM element where our React app will be mounted
const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found. Make sure your HTML has a div with id="root".');
}

// Create React root and render the app
createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
